export default __webpack_public_path__ + "locales/ar-SA/WebPlugins.json?hash=bf02c20a6dc54268541c1904c9b0c867";